
import { mapState } from 'vuex'

export default {
  computed: mapState('toast', ['message', 'icon', 'color']),
}
